export type CredentialStatus = 'Valid' | 'Expiring soon' | 'Expired'
export type LeaveStatus = 'Pending' | 'Approved' | 'Escalated'
export type StockStatus = 'Healthy' | 'Reorder' | 'Critical' | 'Near expiry'
export type PurchaseStatus = 'Awaiting approval' | 'RFQ open' | 'PO issued' | 'GRN pending'

export interface EmployeeRecord {
  id: string
  name: string
  initials: string
  role: string
  department: string
  campus: string
  employment: string
  shift: string
  attendance: 'Present' | 'Late' | 'On leave' | 'Missing punch'
  credential: string
  credentialStatus: CredentialStatus
  expiry: string
}

export interface LeaveRequest {
  id: string
  employee: string
  type: string
  dates: string
  days: number
  coverage: string
  status: LeaveStatus
}

export interface InventoryItem {
  id: string
  code: string
  name: string
  category: string
  store: string
  batch: string
  expiry: string
  onHand: number
  reorderLevel: number
  unit: string
  stockStatus: StockStatus
  value: number
}

export interface PurchaseRequest {
  id: string
  department: string
  requester: string
  description: string
  amount: number
  budget: string
  status: PurchaseStatus
  age: string
}

export const employees: EmployeeRecord[] = [
  { id: 'EMP-00141', name: 'Dr. Imran Sethi', initials: 'IS', role: 'Consultant Cardiologist', department: 'Cardiology', campus: 'Main Hospital', employment: 'Full time', shift: 'Day clinic', attendance: 'Present', credential: 'PMDC 51234-P', credentialStatus: 'Valid', expiry: '30 Sep 2027' },
  { id: 'EMP-00487', name: 'Saira Iqbal', initials: 'SI', role: 'Charge Nurse', department: 'Emergency', campus: 'Main Hospital', employment: 'Full time', shift: '07:00–15:00', attendance: 'Late', credential: 'PNC 194455', credentialStatus: 'Expiring soon', expiry: '02 Aug 2026' },
  { id: 'EMP-00732', name: 'Muhammad Raza', initials: 'MR', role: 'Senior Lab Technologist', department: 'Laboratory', campus: 'Diagnostic Centre', employment: 'Contract', shift: 'Night rotation', attendance: 'Present', credential: 'MLT License', credentialStatus: 'Valid', expiry: '18 Mar 2027' },
  { id: 'EMP-00904', name: 'Ayesha Noor', initials: 'AN', role: 'Resident Medical Officer', department: 'Internal Medicine', campus: 'Main Hospital', employment: 'Trainee', shift: 'On call', attendance: 'Missing punch', credential: 'PMDC 61092-P', credentialStatus: 'Expiring soon', expiry: '29 Jul 2026' },
  { id: 'EMP-01156', name: 'Hira Malik', initials: 'HM', role: 'Procurement Officer', department: 'Supply Chain', campus: 'Corporate Office', employment: 'Full time', shift: '08:30–16:30', attendance: 'On leave', credential: 'Employee verification', credentialStatus: 'Valid', expiry: 'N/A' },
]

export const leaveRequests: LeaveRequest[] = [
  { id: 'LR-2026-184', employee: 'Ayesha Noor · RMO', type: 'Medical leave', dates: '20–23 Jul 2026', days: 4, coverage: 'Dr. Kamran Ali confirmed', status: 'Pending' },
  { id: 'LR-2026-185', employee: 'Hira Malik · Procurement', type: 'Annual leave', dates: '19–25 Jul 2026', days: 7, coverage: 'M. Usman delegated', status: 'Approved' },
  { id: 'LR-2026-187', employee: 'Saira Iqbal · Charge Nurse', type: 'Compensatory leave', dates: '22 Jul 2026', days: 1, coverage: 'ED roster below minimum', status: 'Escalated' },
]

export const inventoryItems: InventoryItem[] = [
  { id: 'itm-1', code: 'MED-CEF-1G', name: 'Ceftriaxone injection 1 g', category: 'Pharmacy', store: 'Central Pharmacy', batch: 'CTX-0626-A', expiry: '31 Aug 2026', onHand: 84, reorderLevel: 120, unit: 'Vials', stockStatus: 'Reorder', value: 147000 },
  { id: 'itm-2', code: 'ER-NOR-4MG', name: 'Noradrenaline 4 mg/4 ml', category: 'Critical care', store: 'ICU Imprest', batch: 'NOR-0426-C', expiry: '30 Apr 2027', onHand: 6, reorderLevel: 20, unit: 'Ampoules', stockStatus: 'Critical', value: 11400 },
  { id: 'itm-3', code: 'LAB-EDTA-2', name: 'EDTA blood collection tube', category: 'Laboratory', store: 'Lab Store', batch: 'EDT-0126-B', expiry: '31 Jan 2027', onHand: 1480, reorderLevel: 600, unit: 'Tubes', stockStatus: 'Healthy', value: 103600 },
  { id: 'itm-4', code: 'OT-SUT-30', name: 'Vicryl suture 3-0', category: 'Operation Theatre', store: 'OT Store', batch: 'VIC-1025-D', expiry: '31 Jul 2026', onHand: 310, reorderLevel: 180, unit: 'Packs', stockStatus: 'Near expiry', value: 279000 },
  { id: 'itm-5', code: 'RAD-CON-100', name: 'Iohexol contrast 100 ml', category: 'Radiology', store: 'Imaging Store', batch: 'IOH-0526-A', expiry: '31 May 2027', onHand: 42, reorderLevel: 30, unit: 'Bottles', stockStatus: 'Healthy', value: 218400 },
]

export const purchaseRequests: PurchaseRequest[] = [
  { id: 'PR-2026-0931', department: 'Emergency', requester: 'N. Ahmed', description: 'Noradrenaline emergency replenishment', amount: 185000, budget: 'CC-ER-001 · 78% used', status: 'Awaiting approval', age: '48 min' },
  { id: 'PR-2026-0928', department: 'Operation Theatre', requester: 'A. Farooq', description: 'Absorbable suture annual rate contract', amount: 1860000, budget: 'CC-OT-001 · within plan', status: 'RFQ open', age: '1 day' },
  { id: 'PR-2026-0914', department: 'Laboratory', requester: 'M. Raza', description: 'CBC analyzer reagent pack', amount: 742000, budget: 'CC-LAB-001 · 66% used', status: 'PO issued', age: '3 days' },
  { id: 'PR-2026-0909', department: 'Cardiology', requester: 'S. Malik', description: 'Cath lab guidewire consignment', amount: 2150000, budget: 'Capital equipment · approved', status: 'GRN pending', age: '5 days' },
]

export const spendByDepartment = [
  { department: 'Pharmacy', spend: 18.6, budget: 20.1 },
  { department: 'Operation Theatre', spend: 14.2, budget: 13.8 },
  { department: 'Laboratory', spend: 8.7, budget: 9.4 },
  { department: 'Emergency', spend: 6.8, budget: 6.2 },
  { department: 'Radiology', spend: 5.4, budget: 6.0 },
]

export const researchMetrics = [
  { label: 'Approved protocols', value: '18', note: '3 awaiting IRB decision' },
  { label: 'Governed datasets', value: '42', note: 'All versioned and access-scoped' },
  { label: 'Active researchers', value: '67', note: 'Role and protocol verified' },
  { label: 'Exports this month', value: '24', note: '0 identity fields released' },
]

export const cohortBreakdown = [
  { label: 'Cardiovascular', value: 38, color: '#0d9488' },
  { label: 'Maternal health', value: 24, color: '#0ea5e9' },
  { label: 'Critical care', value: 19, color: '#f59e0b' },
  { label: 'Oncology', value: 19, color: '#8b5cf6' },
]

export const researchRequests = [
  { id: 'DS-2026-047', title: 'Sepsis care pathway outcomes', investigator: 'Dr. H. Noor · Emergency Medicine', cohort: '1,284 eligible encounters', status: 'IRB review', lastAction: 'Data minimization verified today' },
  { id: 'DS-2026-043', title: 'Antenatal hypertension outcomes', investigator: 'Dr. N. Qureshi · Obstetrics', cohort: '892 eligible encounters', status: 'Approved', lastAction: 'Dataset v3 generated 18 Jul' },
  { id: 'DS-2026-036', title: 'ICU ventilation predictors', investigator: 'Dr. A. Farooq · Critical Care', cohort: '436 eligible encounters', status: 'Export ready', lastAction: 'Secure workspace expires 26 Jul' },
]
